import React, { useEffect } from 'react'

import { useSelector } from 'react-redux'

import { faSitemap, faUserGraduate } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Tabs } from 'antd'

import SupervisedStudents from './SupervisedStudents.jsx'
import Analytics from '../../../utils/analytics.js'
import { isSupervisor } from '../../../utils/roles.js'
import { selectTranslate } from '../../../reducers/LocaleReducer/LocalReducer.js'
import { selectUser } from '../../../reducers/UserReducer/index.js'
import StudentsListView from './StudentsListView/StudentsListView.jsx'

const { TabPane } = Tabs

const SchoolStudentsView = () => {
  const t = useSelector(selectTranslate)
  const user = useSelector(selectUser)

  useEffect(() => Analytics.pageView('/school-students'), [])

  return (
    <Tabs defaultActiveKey='1' animated={false}>
      <TabPane
        key='1'
        tab={
          <div className='flex-row'>
            <FontAwesomeIcon icon={faUserGraduate} style={{ marginTop: '3px' }} />
            <div className='h-spacing' />
            {t('students_view.titles.school_list')}
          </div>
        }
      >
        <StudentsListView />
      </TabPane>
      {isSupervisor(user) &&
        <TabPane
          key='2'
          tab={
            <div className='flex-row'>
              <FontAwesomeIcon icon={faSitemap} style={{ marginTop: '3px' }} />
              <div className='h-spacing' />
              {t('My students')}
            </div>
          }
        >
          <SupervisedStudents />
        </TabPane>}
    </Tabs>
  )
}

export default SchoolStudentsView
